<template>
  <nav class="bg-gray-800 dark:bg-gray-800 p-4">
    <div class="max-w-screen-xl items-center">
      <a href="#" class="text-white text-2xl font-semibold">Server Monitor</a>
    </div>
  </nav>
</template>
  